import { x as u, c as H } from "../lit-element-8JrrHldg.js";
import { n as c } from "../property-4FoNj0Pi.js";
import { c as _ } from "../clsx-DB4S2d7J.js";
import { n as E } from "../ref-ArR26hg7.js";
import { o as p } from "../if-defined-Cd-e8xtV.js";
import "./pwc-icon.js";
import { P as N } from "../pwc-interactive-element-B6286Ky3.js";
import { _ as T, p as M } from "../pwcProperty-CTLG9yrF.js";
import { P as w } from "../pwc-component-size.enum-ldIKEMHl.js";
var Z = /* @__PURE__ */ T(function(n, r) {
  return r instanceof n || r != null && (r.constructor === n || n.name === "Object" && typeof r == "object");
});
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function q(e, n, r) {
  return e ? n(e) : r == null ? void 0 : r(e);
}
const F = (e) => {
  const n = /^(.{0,5}:)?\/\//.test(e) ? "noreferrer noopener" : void 0;
  return p(n);
};
class G extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13.556 8A5.556 5.556 0 1 1 8 2.444v-1.11A6.667 6.667 0 1 0 14.667 8h-1.111Z"></path></svg>';
  }
}
const z = "pi-loading";
customElements.get(z) || customElements.define(z, G);
var J = Object.defineProperty, K = Object.getOwnPropertyDescriptor, o = (e, n, r, s) => {
  for (var i = s > 1 ? void 0 : s ? K(n, r) : n, m = e.length - 1, l; m >= 0; m--)
    (l = e[m]) && (i = (s ? l(n, r, i) : l(i)) || i);
  return s && i && J(n, r, i), i;
};
const O = "pwc-button";
let t = class extends N {
  constructor() {
    super(...arguments), this.slotControlled = [];
  }
  render() {
    const {
      disabled: e,
      primary: n,
      secondary: r,
      critical: s,
      loading: i,
      size: m = w.Medium,
      type: l = "button",
      href: f,
      target: R,
      icon: a,
      iconLeft: P,
      iconRight: B,
      tabIndex: b,
      _form: S,
      name: j,
      value: A,
      formAction: L
    } = this, I = !a && P || void 0, C = !a && B || void 0, y = n || l === "submit" && !r, $ = !y || l === "button" && !n, h = [...Object.values(w)].includes(m) && m || w.Medium, v = [
      "PwcButton",
      `PwcButton--${h}`,
      {
        "PwcButton--primary": y,
        "PwcButton--primary--critical": y && s,
        "PwcButton--primary--disabled": y && e,
        "PwcButton--secondary": $,
        "PwcButton--secondary--critical": s && $,
        "PwcButton--secondary--disabled": e && $,
        "PwcButton--critical": s,
        "PwcButton--disabled": e && !i,
        "PwcButton--loading": i,
        "PwcButton--icon": a
      }
    ], g = (d) => u`
      <pwc-icon
        size="1em"
        icon=${d === "left" ? I : d === "right" ? C : a}
        class="${_("PwcButton__icon", {
      [`PwcButton__icon--${d}`]: d,
      [`PwcButton__icon--${h}`]: d
    })}"
      ></pwc-icon>
    `, D = Z(String, a) && a.length, x = u`
      ${P && !a ? g("left") : ""}
      ${q(
      D,
      () => u`<span hidden><p-slot .host=${this}></p-slot></span>${g()}`,
      () => u`<p-slot .host=${this}></p-slot>`
    )}
      ${B && !a ? g("right") : ""}
    `;
    return f != null && f.length ? u`
        <a
          ref=${E(this.interactiveElementRef)}
          class=${_(v)}
          href=${f}
          target=${p(R)}
          rel=${F(f)}
          tabindex=${p(b)}
        >
          ${x}
        </a>
      ` : u`
      <button
        ref=${E(this.interactiveElementRef)}
        class=${_(v)}
        form=${p(S)}
        type=${l}
        name=${p(j)}
        value=${p(A)}
        ?disabled=${i || e}
        tabindex=${p(b)}
        formaction=${p(L)}
      >
        <span class="PwcButton__inner"> ${x} </span>
        ${i && u`
            <span class="PwcButton__spinner">
              <pwc-icon
                class="${"PwcButton__icon PwcButton__spinner__icon"}"
                icon="loading"
                size="1em"
                color="currentcolor"
              ></pwc-icon>
            </span>
          ` || null}
      </button>
    `;
  }
};
t.tagName = O;
o([
  M({ default: w.Medium })
], t.prototype, "size", 2);
o([
  c({ type: Boolean })
], t.prototype, "disabled", 2);
o([
  c({ type: Boolean })
], t.prototype, "primary", 2);
o([
  c({ type: Boolean })
], t.prototype, "secondary", 2);
o([
  c({ type: Boolean })
], t.prototype, "critical", 2);
o([
  c({ type: Boolean })
], t.prototype, "loading", 2);
o([
  c({ type: String, reflect: !0 })
], t.prototype, "name", 2);
o([
  c({ type: String, reflect: !0 })
], t.prototype, "value", 2);
o([
  c({ type: String, attribute: "formaction" })
], t.prototype, "formAction", 2);
o([
  c()
], t.prototype, "href", 2);
o([
  c()
], t.prototype, "target", 2);
o([
  M({ default: "button" })
], t.prototype, "type", 2);
o([
  c()
], t.prototype, "icon", 2);
o([
  c({ attribute: "icon-left" })
], t.prototype, "iconLeft", 2);
o([
  c({ attribute: "icon-right" })
], t.prototype, "iconRight", 2);
t = o([
  H(O)
], t);
export {
  t as PwcButton
};
